<script>
    import { UserData } from './UserStore.js';
    import { SendRequest, GetUserData, ReleaseMode } from "./APIService";
    import { showModal } from "./Modal";
    
    
    let supportTile = "Support";
    
    if (ReleaseMode == "GLOBAL_TEST") {
        supportTile = "Support";
    }
    else if (ReleaseMode == "IRAN_TEST") {
        supportTile = "پشتیبانی";
    }
    else if (ReleaseMode == "IRAN") {
        supportTile = "پشتیبانی";
    }
    else if(ReleaseMode == "GLOBAL"){
        supportTile = "Support";
    }
    
    let banPushMessage;
    let banDays;
    function BanUser(){
    
        if (typeof banDays == "undefined") {
            checkInputs();
            return;
        }
        if (typeof banPushMessage == "undefined") {
            checkInputs();
            return;
        }
    
        SendRequest("BanUserWithPush", 'POST', 'userId=' + $UserData.id + '&days=' + banDays + '&title=' + supportTile + '&body=' + banPushMessage,
        () => showModal("Ban User", "Done", "OK"));
    }
    
    let sendPushMessage;
    function SendPush(){
        if (typeof sendPushMessage == "undefined") {
            checkInputs();
            return;
        }
        SendRequest("SendPushMessage", 'POST', 'userId=' + $UserData.id + '&title=' + supportTile + '&body=' + sendPushMessage, () => showModal("Send Push", "Done", "OK"));
    }
    
    let newUsername;
    function ChangeUsername(){
        if (typeof newUsername == "undefined") {
            checkInputs();
            return;
        }
        SendRequest("RenameUsernameForce", 'POST', 'userId=' + $UserData.id + '&newUsername=' + newUsername, () => ReloadUserData());
    }
    
    let newEmail;
    function ChangeEmail(){
        if (typeof newEmail == "undefined") {
            checkInputs();
            return;
        }
        SendRequest("SetEmail", 'POST', 'userId=' + $UserData.id + '&newEmail=' + newEmail, () => ReloadUserData());
    }
    
    let newPhoneNumber;
    function ChangePhoneNumber(){
        if (typeof newPhoneNumber == "undefined") {
            checkInputs();
            return;
        }
        SendRequest("SetPhoneNumber", 'POST', 'userId=' + $UserData.id + '&newPhoneNumber=' + newPhoneNumber, () => ReloadUserData());
    }
    
    let newDeviceId;
    function ChangeActiveDeviceId(){
        if (typeof newDeviceId == "undefined") {
            checkInputs();
            return;
        }
        SendRequest("SetActiveDeviceId", 'POST', 'userId=' + $UserData.id + '&newActiveDeviceId=' + newDeviceId, () => ReloadUserData());
    }
    
    let newReferralCode;
    function ChangeReferralCode(){
        if (typeof newReferralCode == "undefined") {
            checkInputs();
            return;
        }
        SendRequest("SetReferralCode", 'POST', 'userId=' + $UserData.id + '&newReferralCode=' + newReferralCode, () => ReloadUserData());
    }
    
    let ticketsToAdd;
    function AddTickets(){
        if (typeof ticketsToAdd == "undefined") {
            checkInputs();
            return;
        }
        SendRequest("AddUserCoinsAndTicketsAndBoosters", 'POST', 'userId=' + $UserData.id + '&tickets=' + ticketsToAdd, () => ReloadUserData());
    }

    let ticketsToAddNegative;
    function AddUserTicketsNegative(){
        if (typeof ticketsToAddNegative == "undefined") {
            checkInputs();
            return;
        }
        SendRequest("AddUserTicketsNegative", 'POST', 'userId=' + $UserData.id + '&tickets=' + ticketsToAddNegative, () => ReloadUserData());
    }
    
    let CoinsToAdd;
    function AddCoins(){
        if (typeof CoinsToAdd == "undefined") {
            checkInputs();
            return;
        }
        SendRequest("AddUserCoinsAndTicketsAndBoosters", 'POST', 'userId=' + $UserData.id + '&coins=' + CoinsToAdd, () => ReloadUserData());
    }
    
    let boosterToAdd;
    function AddBooster(){
        if (typeof boosterToAdd == "undefined") {
            checkInputs();
            return;
        }
        SendRequest("AddUserCoinsAndTicketsAndBoosters", 'POST', 'userId=' + $UserData.id + '&boosterName=' + boosterToAdd, () => ReloadUserData());
    }
    
    let powerupTypeToAdd;
    let amountToAddPowerup;
    function AddPowerups(){
        if (typeof powerupTypeToAdd == "undefined") {
            checkInputs();
            return;
        }
        if (typeof amountToAddPowerup == "undefined") {
            checkInputs();
            return;
        }
        SendRequest("AddPowerup", 'POST', 'userId=' + $UserData.id + '&powerupType=' + powerupTypeToAdd + '&count=' + amountToAddPowerup, () => ReloadUserData());
    }
    
    function UnbanUser(){
        SendRequest("UnBanUser", 'POST', 'userId=' + $UserData.id , () => showModal("Unban", "Done", "OK"));
    }
    
    function SocialBanUser(){
        SendRequest("SocialBanUser", 'POST', 'userId=' + $UserData.id, () => showModal("Social Ban User", "Done", "OK"));
    }

    function SocialUnBanUser(){
        SendRequest("SocialUnBanUser", 'POST', 'userId=' + $UserData.id, () => showModal("Social Unban User", "Done", "OK"));
    }
    
    function ResetRecoveryLimit(){
        SendRequest("RemoveRecoveryLimit", 'POST', 'userId=' + $UserData.id , () => showModal("Reset Recovery Limit", "Done", "OK"));
    }
    
    function downloadPurchases(){
      SendRequest("GetUserPurchases", 'POST',
        "userId=" + $UserData.id +"", (data) => {
    
            var blob = new Blob([JSON.stringify(data, null, '\t')], {
                type: "text/plain;charset=utf-8;",
            });
            saveAs(blob, $UserData.id + "_purchases.json");
        }
      );
    }

    function checkInputs(){
        showModal("Check Inputs", "Some Inputs are missing!", "OK");
    }
    
    function ReloadUserData(){
        if ($UserData?.id){
            GetUserData("Id", $UserData.id);
        }
    }
    
    let vipBundleExtendDays;
    function extendVipBundleDays(){
        if (typeof vipBundleExtendDays == "undefined") {
            checkInputs();
            return;
        }
    
        SendRequest("ExtendVipBundleDays", 'POST', 'userId=' + $UserData.id + '&days=' + vipBundleExtendDays, () => ReloadUserData());
    }

    function addVipBundleForUser(){
        SendRequest("AddVipBundleForUser", 'POST', 'userId=' + $UserData.id, () => ReloadUserData());
    }
    
    </script>
    
    
    <div class="card col-md-12">
        <h5 class="card-header"><h3>Action</h3></h5>
        <div class="card-body">
    
            <div class="row justify-content-md-center">
                <!-- Ban User -->
                <div class="card col-md-6">
                    <div class="card-title">
                    Ban User
                    </div>
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Ban Push Message" bind:value={banPushMessage}>
                            <input type="text" class="form-control" placeholder="Days" bind:value={banDays}>
                            <div class="input-group-append">
                            <button class="btn btn-danger" type="button" on:click={BanUser}>BanUser</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Send Push -->
                <div class="card col-md-4">
                    <div class="card-title">
                        Send Push
                    </div>
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Push Message" bind:value={sendPushMessage}>
                            <div class="input-group-append">
                            <button class="btn btn-info" type="button" on:click={SendPush}>SendPush</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="row justify-content-md-center">
                <!-- Change Username -->
                <div class="card col-md-3">
                    <div class="card-title">
                        Change Username
                    </div>
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="New Username" bind:value={newUsername}>
                            <div class="input-group-append">
                            <button class="btn btn-info" type="button" on:click={ChangeUsername}>Change</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Change Email -->
                <div class="card col-md-3">
                    <div class="card-title">
                        Change Email
                    </div>
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="New Email" bind:value={newEmail}>
                            <div class="input-group-append">
                            <button class="btn btn-info" type="button" on:click={ChangeEmail}>Change</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Change PhoneNumber -->
                <div class="card col-md-3">
                    <div class="card-title">
                        Change PhoneNumber
                    </div>
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="New Phone Number" bind:value={newPhoneNumber}>
                            <div class="input-group-append">
                            <button class="btn btn-info" type="button" on:click={ChangePhoneNumber}>Change</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Change Active Device Id -->
                <div class="card col-md-3">
                    <div class="card-title">
                        Change Active Device
                    </div>
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="New ActiveDeviceId" bind:value={newDeviceId}>
                            <div class="input-group-append">
                            <button class="btn btn-info" type="button" on:click={ChangeActiveDeviceId}>Change</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Change ReferralCode -->
                <div class="card col-md-2">
                    <div class="card-title">
                        Change Referral Code
                    </div>
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="New Referral Code" bind:value={newReferralCode}>
                            <div class="input-group-append">
                            <button class="btn btn-info" type="button" on:click={ChangeReferralCode}>Change</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="row justify-content-md-center">
                <!-- AddTickets Negative  -->
                <div class="card col-md-2">
                    <div class="card-title">
                        Add Tickets Negative
                    </div>
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="e.g. 20" bind:value={ticketsToAddNegative}>
                            <div class="input-group-append">
                            <button class="btn btn-success" type="button" on:click={AddUserTicketsNegative}>Add</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- AddTickets  -->
                <div class="card col-md-2">
                    <div class="card-title">
                        Add Tickets
                    </div>
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="e.g. 20" bind:value={ticketsToAdd}>
                            <div class="input-group-append">
                            <button class="btn btn-success" type="button" on:click={AddTickets}>Add</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- AddCoins  -->
                <div class="card col-md-2">
                    <div class="card-title">
                        Add Coins
                    </div>
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="e.g. 200" bind:value={CoinsToAdd}>
                            <div class="input-group-append">
                            <button class="btn btn-success" type="button" on:click={AddCoins}>Add</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- AddBooster  -->
                <div class="card col-md-3">
                    <div class="card-title">
                        Add Booster
                    </div>
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <select class="custom-select" id="inputGroupSelect04" bind:value={boosterToAdd}>
                                <option selected value="DaubAlert1" >DaubAlert1</option>
                                <option value="DaubAlert2" >DaubAlert2</option>
                                <option value="DaubAlert3" >DaubAlert3</option>
                                <option value="12Hours" >12Hours</option>
                            </select>
                            <div class="input-group-append">
                            <button class="btn btn-success" type="button" on:click={AddBooster}>Add</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- AddBooster  -->
                <div class="card col-md-3">
                    <div class="card-title">
                        Add Powerup
                    </div>
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <select class="custom-select" id="inputGroupSelect04"  bind:value={powerupTypeToAdd}>
                                <option selected value="Chest">Chest</option>
                                <option value="Coin">Coin</option>
                                <option value="DoubleReward">DoubleReward</option>
                                <option value="Xp">Xp</option>
                                <option value="OneFill">OneFill</option>
                                <option value="TwoFill">TwoFill</option>
                                <option value="BingoStar">BingoStar</option>
                                <option value="SuperCharger">SuperCharger</option>
                            </select>
                            <input type="text" class="form-control" placeholder="e.g. 5" bind:value={amountToAddPowerup}>
                            <div class="input-group-append">
                            <button class="btn btn-success" type="button" on:click={AddPowerups}>Add</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- extendVipBundleDays  -->
                <div class="card col-md-2">
                    <div class="card-title">
                        Extend Vip Bundle Days
                    </div>
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="e.g. 5" bind:value={vipBundleExtendDays}>
                            <div class="input-group-append">
                            <button class="btn btn-success" type="button" on:click={extendVipBundleDays}>Extend</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- addVipBundleForUser  -->
                <div class="card col-md-2">
                    <div class="card-title">
                        Add Vip Bundle
                    </div>
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <div class="input-group-append">
                            <button class="btn btn-success" type="button" on:click={addVipBundleForUser}>Give</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="row justify-content-md-center">
                <div class="card col-md-7">
                    <div class="card-title">
                        OtherActions
                    </div>
                    <div class="card-body">
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-danger" style="margin: 2px;" on:click={SocialBanUser}>Social BanUser</button>
                            <button type="button" class="btn btn-warning" style="margin: 2px;" on:click={SocialUnBanUser}>Social UnBanUser</button>
                            <button type="button" class="btn btn-warning" style="margin: 2px;" on:click={UnbanUser}>UnBanUser</button>
                            <button type="button" class="btn btn-primary" style="margin: 2px;" on:click={ResetRecoveryLimit}>ResetRecoveryLimit</button>
                            <button type="button" class="btn btn-info" style="margin: 2px;" on:click={downloadPurchases}>DownloadPurchases</button>
                            <!-- <button type="button" class="btn btn-danger">BanDevice</button>
                            <button type="button" class="btn btn-warning">UnBanDevice</button> -->
                        </div>
                    </div>
                </div>
            </div>
    
    
        </div>
    </div>
    
    
      <style>
          .card{
              margin: 5px;
          }
      </style>